<template>
  <el-dialog
    :visible.sync="showDialog"
    width="480px"
    :before-close="handleCancel"
  >
    <div slot="title" class="title">切换支付方式</div>
    <div class="tips-wrap">
      <span>1、只有状态为“待修改”的代采单才能切换。</span>
      <span>2、A1表头=代采订单编号，从A2~A正无限，填入代采单编号。</span>
      <span>3、切换为“上传回执”会同时完成支付。</span>
      <span>4、单次最多200个ID。</span>
    </div>
    <el-form
      ref="tableForm"
      :model="checkForm"
      label-width="100px"
      :rules="rules"
    >
      <el-form-item label="导入切换为:" prop="methods">
        <el-radio-group v-model="checkForm.methods">
          <el-radio label="1">转账支付 </el-radio>
          <el-radio label="2">上传回执 </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        v-show="checkForm.methods === '2'"
        label="上传回执:"
        prop="receipt"
      >
        <YsUpload v-model="checkForm.receipt" :max="1"></YsUpload>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="info" size="small" @click="handleCancel">
        取 消</el-button
      >
      <el-upload
        ref="uploadUpdateCutPayRef"
        :max="1"
        name="excel"
        :data="checkForm"
        upload-type="excel"
        :show-file-list="false"
        :before-upload="beforeUpload"
        :action="actionUrl"
        :with-credentials="true"
        style="display: inline-block; margin-left: 10px"
        :on-success="importUpdateCutPaySuccess"
        :on-error="(data) => $message.error('导入发生错误, 请及时联系技术')"
      >
        <el-button size="small" type="success">导入代采单</el-button>
      </el-upload>
    </div>
  </el-dialog>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  name: "DefectiveTypeDialog",

  props: {
    selectOptions: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      showDialog: false,
      isEdit: false,
      checkForm: {
        methods: "",
        receipt: "",
      },
      parentCategory: [],
      actionUrl: `${apiBaseURL}/erp/WcgOrder/switchingPaymentMethods`,
      rules: {
        methods: [
          { required: true, message: "请选择切换类型", trigger: "blur" },
        ],
        receipt: [
          {
            required: true,
            trigger: "blur",
            validator: (rule, value, callback) => {
              if (this.checkForm.methods === "2" && !value) {
                callback(new Error("请上传回执"));
              } else {
                callback();
              }
            },
          },
        ],
      },
    };
  },
  methods: {
    importUpdateCutPaySuccess(res) {
      // 清空上传的文件
      this.$refs.uploadUpdateCutPayRef.clearFiles();
      const { data, msg, code } = res;
      if (code !== 200) {
        this.$message({
          message: msg,
          type: "error",
        });
        if (data.file) {
          // 延迟导出 提示报错
          setTimeout(() => {
            window.open(apiBaseURL + data.file);
          }, 2000);
        }
      } else {
        this.$message({
          message: "操作成功",
          type: "success",
        });
        this.handleCancel();
      }
    },
    beforeUpload() {
      this.$refs.tableForm.validate((valid) => {
        if (valid) {
          // 转账支付去除凭证图片的上传
          if (this.checkForm.methods === "1") {
            this.checkForm.receipt = "";
          }
          return true;
        }
        return false;
      });
    },
    showDialogModal() {
      this.showDialog = true;
    },
    handleCancel() {
      this.$refs.tableForm.resetFields();
      this.showDialog = false;
      this.checkForm = this.$options.data().checkForm;
    },
  },
};
</script>

<style scoped>
.title {
  /* text-align: center; */
  font-size: 18px;
  font-weight: 500;
  border-bottom: 2px solid #666;
  padding-bottom: 16px;
}
.tips-wrap {
  display: flex;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/pages/CutPayModeDialog.vue